<template>
    <div id="operationFlow">
        <p class="serviceTitle"><span>解决方案流程</span></p>
        <div id="flowWrapper">
            <ul>
                <li>
                    <div class="imgBox"></div>
                    <div class="imgNext"></div>
                    <P>方案需求</P>
                </li>
                <li>
                    <div class="imgBox"></div>
                    <div class="imgNext"></div>
                    <P>实地调研</P>
                </li>
                <li>
                    <div class="imgBox"></div>
                    <div class="imgNext"></div>
                    <P>方案制作</P>
                </li>
                <li>
                    <div class="imgBox"></div>
                    <div class="imgNext"></div>
                    <P>方案论证</P>
                </li>
                <li>
                    <div class="imgBox"></div>
                    <div class="imgNext"></div>
                    <P>方案实施</P>
                </li>
                <li>
                    <div class="imgBox"></div>
                    <P>长期服务</P>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name: 'List3',
}
</script>

<style scoped>
    #flowWrapper{
        height: 180px;
        background: url(../../../assets/imgs/service/flowbg.png);
        background-size: 100% 100%;
    }
    #flowWrapper>ul{
        padding: 25px ;
        width: 915px;
        margin: 0 auto;
        overflow: hidden;
    }
    #flowWrapper>ul>li{
        width: calc((100% - 321px) / 6);
        margin-right: 64px;
        float: left;
        position: relative;
    }
    .imgBox{
        width: 100%;
        height: 99px;
        margin-bottom: 10px;
    }
    #flowWrapper>ul>li:nth-child(1) .imgBox{
        background: url(../../../assets/imgs/service/flow6.png) no-repeat;
        background-size: 100% 100%;
    }
    #flowWrapper>ul>li:nth-child(2) .imgBox{
        background: url(../../../assets/imgs/service/flow1.png) no-repeat;
        background-size: 100% 100%;
    }
    #flowWrapper>ul>li:nth-child(3) .imgBox{
        background: url(../../../assets/imgs/service/flow2.png) no-repeat;
        background-size: 100% 100%;
    }
    #flowWrapper>ul>li:nth-child(4) .imgBox{
        background: url(../../../assets/imgs/service/flow4.png) no-repeat;
        background-size: 100% 100%;
    }
    #flowWrapper>ul>li:nth-child(5) .imgBox{
        background: url(../../../assets/imgs/service/flow3.png) no-repeat;
        background-size: 100% 100%;
    }
    #flowWrapper>ul>li:nth-child(6) .imgBox{
        background: url(../../../assets/imgs/service/flow5.png) no-repeat;
        background-size: 100% 100%;
    }
    #flowWrapper>ul>li:nth-child(6){
        margin-right: 0;
    }
    .imgNext{
        width: 15px;
        height: 32px;
        position: absolute;
        top: 40px;
        right: -40px;
        overflow: hidden;
        background: url(../../../assets/imgs/service/flow.png) no-repeat;
    }
    #flowWrapper>ul>li p{
        color: #fff;
        text-align: center;
    }
</style>
